import { render, staticRenderFns } from "./farmshotsComponent.vue?vue&type=template&id=d4fc6a22&"
import script from "./farmshotsComponent.vue?vue&type=script&lang=js&"
export * from "./farmshotsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports